import React,{useEffect} from "react";
import { Link,useParams } from "react-router-dom";
import { LogoOriginal } from "../_components/Imagepath";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";


import PropTypes from "prop-types";

import { useAuth } from "../context/AuthContext";
import SupportButtonHeader from "./common/SupportButtonHeader";
import { schema } from "../schema/schemaRegisterSupplierStaff";
import InvitedEmailField from "./common/InvitedEmailField"
import { useTranslation } from "react-i18next";
import Lang from "../common/Lang";
const RegisterSupplierStaff = (props) => {
  const {user} = useAuth();
 const { t } = useTranslation();
  useEffect(() => {
    
    if (user?.token){
  
      history.push('/dashboard')
  }
  }, [user]);

  RegisterSupplierStaff.propTypes = {
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }).isRequired,
  };
  const url = window.location.href;

  const idMatch = url.match(/id=([^&]+)/);
  const tokenMatch = url.match(/token=([^&]+)/);
  
  const idsupplier = idMatch ? idMatch[1] : null;
  const token = tokenMatch ? tokenMatch[1] : null;
  

  
 
  const { history } = props;
  const inputValues = {
    name: "",
    email: "",
      phone: "",
    password1: "",
    password2: "",
    token: token,
    supplier:idsupplier
  };


const { reset, handleSubmit, setError, clearErrors, register,setValue, formState: { errors } } = useForm({
  resolver: yupResolver(schema(t)),
  defaultValues: inputValues, 
});
useEffect(() => {
  reset(inputValues);
}, [reset]);

  const auth = useAuth();

  const onSubmit = async(data) => {
 
      
    /*
      if (data.password1 !== data.password2) {
        setError("password2", {
          message: "Password is mismatched",
        });
      } else {
        clearErrors("password1");
      //  history.push("/index");  // <-- Use this instead of history.push
      }*/
      clearErrors(); // Clears all errors

    
      auth.register("supplier-staff",data, (error) => {
        if (!error) {
          history.push("/dashboard"); // Redirect on success
        } else {
         
   
      

      
        let errorMessage = false; // Initialize the error message variable
       
        if (error?.response?.data?.token) {
          errorMessage = error.response.data.token;
          setError("root", { type: "server", message: errorMessage });
          return
        }
        if (error?.response?.data?.supplier) {
          errorMessage = error.response.data.supplier;
          setError("root", { type: "server", message: errorMessage });
          return
        }
        
        // Handle other errors dynamically
        if (error?.response?.data) {
          errorMessage = ""
          Object.entries(error.response.data).forEach(([key, values]) => {
            if (key !== "token" && key !== "supplier") {
              
              errorMessage += `${values}\n`;
            }
          });
        }
      
        // If no specific error was found, provide a default message
        if (!errorMessage) {
         
          errorMessage = "An unknown error occurred.";
        }
        
        // Set the error message in React Hook Form
        setError("root", { type: "server", message: errorMessage });
        
        }
      });
    
      
  };

  return (
    <div className="main-wrapper  login-body">
      <div className="login-wrapper">
        <div className="container">
          <img
            className="img-fluid logo-dark mb-2"
            src={LogoOriginal}
            alt="Logo"
          />

          <div className="loginbox">
            <div className="login-right">
              <div className="login-right-wrap">
                <h1>{t("Register")}</h1>
                <p className="account-subtitle">{t("Access to our dashboard")}</p>

                {/* Form */}
                <form onSubmit={handleSubmit(onSubmit)}>
              
  <div className="input-block mb-3">
    <label className="form-control-label">{t("Name")}</label>
    <input className="form-control" type="text" {...register("name")} />
    <p className="text-danger">{errors.name?.message}</p>
  </div>

                   {/** InvitedEmailField section */}
                <InvitedEmailField token={token}  register={register} setError={setError} setValue={setValue}errors={errors}/>
  {/** end InvitedEmailField section */}
  
  
   <div className="input-block mb-3">
                    <label className="form-control-label">{t("Contact Number")}</label>
                    <input
                      className="form-control"
                      type="tel"
                    
                      {...register("phone")}
                    />
                    <p className="text-danger">{errors.phone?.message}</p>
                  </div>
  
  
  <div className="input-block mb-3">
    <label className="form-control-label">{t("Password")}</label>
    <input className="form-control" type="password" {...register("password1")} />
    <p className="text-danger">{errors.password1?.message}</p>
  </div>
  <div className="input-block mb-3">
    <label className="form-control-label">{t("Confirm Password")}</label>
    <input className="form-control" type="password" {...register("password2")} />
    <p className="text-danger">{errors.password2?.message}</p>
  </div>
  <div className="input-block mb-0">
    <button type="submit" className="btn btn-lg btn-block btn-primary w-100">
      {t("Register")}
      {auth.credLoading && <i className="fa-solid fa-spinner fa-spin" style={{margin: "0 10px"}}></i> }

    </button>
    <small style={{color:"red"}}> {errors.root && <p>{errors.root.message}</p>}</small>
  </div>
</form>
                {/* /Form */}

                <div className="login-or">
                  <span className="or-line"></span>
                  <span className="span-or">or</span>
                </div>
       
                <div className="text-center dont-have">
                  {t("Already have an account?")} <Link to="/login">{t("Login")}</Link>
                </div>
              </div>
            </div>
          </div>
          <div className="lang-menu">
                <ul className="nav nav-tabs user-menu">
               
                 <SupportButtonHeader/>
                  <div className="lang-item ">
      <Lang />
      </div>
                </ul>

              </div>
        </div>
      </div>
    </div>
  );
};
export default RegisterSupplierStaff;
